module.exports = __webpack_public_path__ + "static/media/main idea.1ae9e049.mp3";